export default {"src":"/_next/static/media/IconLuggage.94084656.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};